  $(document).ready(function(){
    $(window).on('load',function(){
      $('.qty-value').val(0);
    });

    $(document).on('click','.cstm-minus',function(){
  var quantityInput = $(this).siblings('.qty-value'); 
  var currentValue = parseInt(quantityInput.val()); 
  if (currentValue > 0) { 
    quantityInput.val(currentValue - 1); 
  }
  var finalqty = quantityInput.val(); 
  $(this).siblings('.final-qty-value').val(finalqty);
    });
    
    $(document).on('click','.cstm-plus',function(){
  var quantityInput = $(this).siblings('.qty-value'); 
  var currentValue = parseInt(quantityInput.val());
  quantityInput.val(currentValue + 1); 
  var finalqty = quantityInput.val(); 
   $(this).siblings('.final-qty-value').val(finalqty);
    });
$('.table-pro-items .qty-value').on('keyup input change', function() {
  const $wrapper = $(this).closest('.qty-wrapper');
  $wrapper.find('.final-qty-value').val($(this).val());
});


     $(document).on('click','.buy-tog-btn',function(){

  var products = [];
  $('.final-qty-value').each(function(){
    var pid = $(this).attr('data-id');
    // var qty = $(this).attr('data-qty');
    var qty = $(this).val();
    // alert(qty);
    if(qty > 0){
    products.push({
      'id': pid,
      'quantity': qty
    });
    }
  });

  if (products.length === 0) {
    alert("Please select at least one product.");
    return;
  }

       
  // console.log(products);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: products }), 
    dataType: 'JSON',
    contentType: 'application/json',
    success: function(data){
     window.location.href = "/cart";
    }
  });
});

    $(document).on('click', '.buy-now-btn', function () {
  var products = [];

  $('.final-qty-value').each(function () {
    var pid = $(this).attr('data-id');
    var qty = $(this).val();

    if (qty > 0) {
      products.push({
        id: pid,
        quantity: qty
      });
    }
  });

  if (products.length === 0) {
    alert("Please select at least one product.");
    return;
  }

  // console.log(products);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: products }),
    dataType: 'json',
    contentType: 'application/json',
    success: function (data) {
      window.location.href = '/checkout';
    },
    error: function (xhr, status, error) {
      alert("Something went wrong. Please try again.");
      console.error(xhr.responseText);
    }
  });
});


  });
